<template>
  <div>
      <br><br>
      <h6 class="text-left font-weight-bold">{{$t('how_do_i_answer_the_questionnaire')}}</h6>
      <ul class="text-left">
        <li>{{$t('precautions_sentence1')}}</li>
        <li>{{$t('precautions_sentence2')}}</li>
        <li><strong>{{$t('precautions_sentence4_talent')}}</strong>
            <ul class="text-left">
              <li>{{$t('precautions_sentence41_talent')}}</li>
              <li>{{$t('precautions_sentence42_talent')}}</li>
          </ul>
        </li>
      </ul>
      <p class="text-left">{{$t('precautions_sentence5')}}</p>
      <p class="text-left"><strong>{{$t('technical_note')}}</strong>: {{$t('precautions_sentence6')}} <a href="http://windowsupdate.microsoft.com/" target="_blank">{{$t('windows_update')}}</a>. {{$t('precautions_sentence7')}} <a href="http://www.mozilla.com/en-US/" target="_blank">{{$t('download')}}</a> {{$t('precautions_sentence8')}}</p>
      <button class="btn-rounded btn btn-info btn-sm ripple-parent" @click="questionnaire">{{$t('start_the_questionnaire')}}</button>
  </div>
</template>

<script>
export default {
    name: 'TalentInstructions',
    data: () => ({
      active: 'first',
      first: false,
      second: false,
      windowWidth: 0,
      windowHeight: 0,
    }),
    methods: {
      setDone (id, index) {
        this[id] = true
        if (index) {
          this.active = index
          this.backToTop();
        }
      },
      questionnaire(){
        this.$router.push({path:'questionnaire-talents'});
      },
      getWindowWidth(event) {
        this.windowWidth = document.documentElement.clientWidth;
      },
      getWindowHeight(event) {
        this.windowHeight = document.documentElement.clientHeight;
      },
      backToTop(){
        $('html,body').stop().animate({
            scrollTop: 0
        }, 'slow', 'swing');
      }
    },
    mounted() {
        this.$nextTick(function() {
          window.addEventListener('resize', this.getWindowWidth);
          window.addEventListener('resize', this.getWindowHeight);

          //Init
          this.getWindowWidth()
          this.getWindowHeight()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    }
}
</script>

<style lang="css" scoped>
.video-border {
width: 50%;
border: 5px solid #33b5e5;
}
@media (max-width: 768px) {
.video-border {
width: 100%;
}
}
.md-dialog {
  max-width: 587px;
  border: 4px solid #33b5e5;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  box-shadow: 2px 2px 6px rgba(0,0,0,0.6);
}

.start-question {
  margin-right: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/TalentInstructions.vue